var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabMedicalLetterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1C18.07 1 23 5.93 23 12C23 18.07 18.07 23 12 23C5.93 23 1 18.07 1 12C1 5.93 5.93 1 12 1ZM12 0C5.37 0 0 5.37 0 12C0 18.63 5.37 24 12 24C18.63 24 24 18.63 24 12C24 5.37 18.63 0 12 0Z",
    fill: "#2560A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.33 6.76H5.67005C5.60005 6.76 5.54005 6.78 5.49005 6.82C5.48005 6.82 5.46005 6.84 5.45005 6.85C5.40005 6.89 5.36005 6.93 5.33005 6.99C5.33005 6.99 5.30005 7.09 5.30005 7.14V16.52C5.30005 16.73 5.47005 16.9 5.68005 16.9H18.35C18.56 16.9 18.73 16.73 18.73 16.52V7.14C18.73 7.09 18.72 7.04 18.7 6.99C18.67 6.93 18.63 6.88 18.58 6.84C18.57 6.84 18.56 6.82 18.54 6.81C18.48 6.78 18.42 6.75 18.36 6.75L18.33 6.76ZM11.16 12.38L6.54005 7.51H17.46L12.83 12.38H11.16ZM11 13.13H12.99C13.09 13.13 13.19 13.09 13.26 13.01L17.96 8.07V16.14H6.04005V8.08L10.73 13.02C10.8 13.09 10.9 13.14 11 13.14V13.13Z",
    fill: "#2560A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.59 8.47H11.41V9.36H10.52V10.54H11.41V11.43H12.59V10.54H13.48V9.36H12.59V8.47Z",
    fill: "#2560A0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_37"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabMedicalLetterIcon);
export default __webpack_public_path__ + "static/media/TabMedicalLetterIcon.53685447cbac9637cc73097c2bfa607d.svg";
export { ForwardRef as ReactComponent };